<template>
    <div class="card shadow-sm mb-3">
        <div class="card-header">
            <span v-if="isParentGrouping">Hauptgruppierung</span>
            <span v-else>Untergruppierung</span>
        </div>
        <div class="card-body">
            <div class="form-group">
                <label>Gruppieren nach</label>
                <select class="form-control" v-model="config.type">
                    <option :value="null" v-if="!isParentGrouping">Ohne Untergruppe</option>
                    <option value="bga">BGA</option>
                    <option value="pzn">PZN</option>
                    <option value="anbieter">Anbieter</option>
                    <option value="darreichungsform">Darreichungsform</option>
                    <option value="warengruppe">Warengruppe</option>
                    <option value="time" v-if="isParentGrouping">Zeit</option>
                    <option value="bga_sales">BGA Umsatz</option>
                    <option value="bga_zip">BGA PLZ</option>
                    <option value="wholesalers">Großhändler</option>
                    <option value="custom">Eigene Gruppierung</option>
                </select>
            </div>

            <div v-show="config.type === 'warengruppe'">
                <div class="form-group">
                    <label>Warengruppe Maske</label>
                    <select class="form-control" v-model="config.warengruppeMask">
                        <option :value="2">AB******</option>
                        <option :value="4">ABCD****</option>
                        <option :value="5">ABCDE***</option>
                        <option :value="6">ABCDEF**</option>
                        <option :value="8">ABCDEFGH</option>
                    </select>
                </div>
            </div>

            <div v-show="config.type === 'time'">
                <div class="form-group">
                    <label>Zeit Modus</label>
                    <select class="form-control" v-model="config.timeMode">
                        <option value="monthly">Monatlich</option>
                        <option value="quarterly">Quartalsweise</option>
                        <option value="yearly">Jährlich</option>
                    </select>
                </div>
            </div>

            <div v-show="config.type === 'bga_sales'">
                <div class="form-group">
                    <label>Umsatz Modus</label>
                    <select class="form-control" v-model="config.bgaSalesMode">
                        <option value="sell_in">Sell In</option>
                        <option value="sell_out">Sell Out</option>
                    </select>
                </div>

                <div class="form-group" v-show="config.bgaSalesMode === 'sell_in'">
                    <label>Umsatz Sell In Modus</label>
                    <select class="form-control" v-model="config.bgaSalesSellInMode">
                        <option value="grosshandel">Großhandel</option>
                        <option value="anbieter">Direkt</option>
                        <option value="all">Beides</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Umsatz Sortiment</label>
                    <select class="form-control" v-model="config.bgaSalesAbgaberegelung">
                        <option value="all">Kein Filter</option>
                        <option value="rx_no_high">RX ohne Hochpreiser</option>
                        <option value="nonrx_full">Non RX</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Umsatz Stufen (Alle X €)</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input type="text" class="form-control" placeholder="0" v-model="config.bgaSalesStepping">
                    </div>
                </div>

                <div class="form-group">
                    <label>Umsatz Minimum (Bis X €, optional)</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input type="text" class="form-control" placeholder="0" v-model="config.bgaSalesMin">
                    </div>
                </div>

                <div class="form-group">
                    <label>Umsatz Maximum (Mehr als X €, optional)</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input type="text" class="form-control" placeholder="0" v-model="config.bgaSalesMax">
                    </div>
                </div>
            </div>

            <div v-show="config.type === 'bga_zip'">
                <div class="form-group">
                    <label>PLZ Maske</label>
                    <select class="form-control" v-model="config.bgaZipMask">
                        <option :value="1">0****</option>
                        <option :value="2">01***</option>
                        <option :value="3">012**</option>
                        <option :value="4">0123*</option>
                        <option :value="5">01234</option>
                    </select>
                </div>
            </div>

            <div v-show="config.type === 'custom'">
                <div class="form-group">
                    <label>Liste (Typ Universal Gruppen)</label>
                    <select class="form-control" v-model="config.universalGroupsListId">
                        <option :value="null">Bitte auswhählen</option>
                        <option :value="list.id" v-for="list in universalGroupsLists">
                            {{ list.title }} ({{ Object.keys(list.config.content).length }} Gruppen)
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
                <label>Sichtbare Spalten:</label>
                <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                    <input class="form-check-input"
                           type="checkbox"
                           :id="uuid + column.id"
                           :value="column.id"
                           :checked="!config.hiddenColumns.includes(column.id)"
                           @change="toggleHiddenColumns(column.id, $event)">
                    <label class="form-check-label" :for="uuid + column.id">
                        {{ column.label }}
                    </label>
                </div>
            </div>

            <div class="form-check" v-if="config.type">
                <input class="form-check-input" type="checkbox" value="" :id="uuid + '-remove-empty'"
                       v-model="config.removeEmptyRows">
                <label class="form-check-label" :for="uuid + '-remove-empty'">
                    Leere Zeilen ausblenden
                </label>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        options: {
            type: Object,
            required: true
        },
        dto: {
            type: Object,
            required: true
        },
        isParentGrouping: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            uuid: this.$uuid.v4(),
            config: this.dto
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        universalGroupsLists() {
            return (this.options.lists['universal-groups'] || []);
        },
        selectableVisibleColumns() {
            if (this.config.type === 'bga') {
                return [
                    {id: 'bga', label: 'BGA'},
                    {id: 'name', label: 'Name'},
                    {id: 'city', label: 'Ort'},
                    {id: 'start', label: 'Start'},
                    {id: 'end', label: 'Ende'},
                    {id: 'coop', label: 'Kooperation'},
                ];
            }
            if (this.config.type === 'pzn') {
                return [
                    {id: 'pzn', label: 'PZN'},
                    {id: 'name', label: 'Artikel'},
                    {id: 'size', label: 'Größe'},
                    {id: 'dar', label: 'Dar.form'},
                    {id: 'anbieter', label: 'Anbieter'},
                    {id: 'anbieter-name', label: 'Firma'},
                ];
            }
            if (this.config.type === 'anbieter') {
                return [
                    {id: 'anbieter', label: 'Anbieter'},
                    {id: 'anbieter-name', label: 'Firma'},
                ];
            }
            if (this.config.type === 'darreichungsform') {
                return [
                    {id: 'darreichungsform', label: 'Dar.'},
                    {id: 'darreichungsform-name', label: 'Name'},
                ];
            }
            if (this.config.type === 'warengruppe') {
                return [
                    {id: 'warengruppe', label: 'Warengruppe'},
                    {id: 'warengruppe-name', label: 'Name'},
                ];
            }
            if (this.config.type === 'time') {
                return [
                    {id: 'time', label: 'Zeitraum'},
                ];
            }
            if (this.config.type === 'bga_sales') {
                return [
                    {id: 'sales', label: 'Umsatzgruppe'},
                ];
            }
            if (this.config.type === 'bga_zip') {
                return [
                    {id: 'zip', label: 'PLZ'},
                ];
            }
            if (this.config.type === 'custom') {
                return [
                    {id: 'group', label: 'Gruppe mit Basis'},
                ];
            }

            return [];
        },
    },
    watch: {
        'config.type'() {
            this.config.hiddenColumns = [];
        },
    }
}
</script>
